import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyAiqJq3eS2NrJlBUt_-70ajhb4TmftyJ7Y",
  authDomain: "tapsody-7f358.firebaseapp.com",
  databaseURL: "https://tapsody-7f358-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "tapsody-7f358",
  storageBucket: "tapsody-7f358.firebasestorage.app",
  messagingSenderId: "811003231629",
  appId: "1:811003231629:web:e0c2d5022350f36a11d1c4"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const database = getDatabase(app);
export const storage = getStorage(app);
export default app;